<template>
  <div class="loader"><div class="spinner"/></div>
</template>
<script>
export default {

}
</script>
